var $60b123ff2f7d0569$exports = {};
$60b123ff2f7d0569$exports = {
    "loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "placeholder": `\u{5D1}\u{5D7}\u{5E8}\u{2026}`
};


export {$60b123ff2f7d0569$exports as default};
//# sourceMappingURL=he-IL.mjs.map
